export const ONE_SHOT_LICENSE_FAMILY_NAMES = ["One Shot", "one-shot"];
